import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { FlowNode } from '../../../types/flowBuilder';
import { ArrowPathIcon } from '@heroicons/react/24/outline';

const LoopNode: React.FC<NodeProps<FlowNode['data']>> = ({ data, selected }) => {
  return (
    <div className={`px-4 py-3 shadow-lg rounded-lg bg-gradient-to-r from-amber-400 to-amber-500 border-2 transition-all duration-200 ${
      selected ? 'border-amber-600 shadow-xl scale-105' : 'border-amber-300'
    }`}>
      <div className="flex items-center space-x-3">
        {/* Icon */}
        <div className="flex-shrink-0">
          <div className="w-8 h-8 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
            <ArrowPathIcon className="w-5 h-5 text-white" />
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          <div className="text-sm font-semibold text-white truncate">
            {data.label}
          </div>
          {data.description && (
            <div className="text-xs text-amber-100 truncate mt-1">
              {data.description}
            </div>
          )}
          
          {/* Config preview */}
          {data.config?.maxIterations && (
            <div className="text-xs text-amber-100 mt-1">
              Max: {data.config.maxIterations} iteráció
            </div>
          )}
        </div>

        {/* Status indicator */}
        <div className="flex-shrink-0">
          <div className={`w-3 h-3 rounded-full ${
            data.hasError ? 'bg-red-500' : 'bg-green-400'
          }`} />
        </div>
      </div>

      {/* Error message */}
      {data.hasError && data.errorMessage && (
        <div className="mt-2 text-xs text-red-200 bg-red-500 bg-opacity-20 px-2 py-1 rounded">
          {data.errorMessage}
        </div>
      )}

      {/* Execution data preview */}
      {data.executionData && (
        <div className="mt-2 text-xs text-amber-100 bg-black bg-opacity-20 px-2 py-1 rounded">
          <div className="font-mono">
            Iteráció: {data.executionData.currentIteration || 0}/{data.config?.maxIterations || 0}
          </div>
        </div>
      )}

      {/* Input handle */}
      <Handle
        type="target"
        position={Position.Left}
        id="input"
        className="w-3 h-3 bg-white border-2 border-amber-500"
        style={{ left: -6 }}
      />

      {/* Loop body output */}
      <Handle
        type="source"
        position={Position.Bottom}
        id="loop-body"
        className="w-3 h-3 bg-white border-2 border-amber-500"
        style={{ bottom: -6 }}
      />

      {/* Completion output */}
      <Handle
        type="source"
        position={Position.Right}
        id="complete"
        className="w-3 h-3 bg-white border-2 border-amber-500"
        style={{ right: -6 }}
      />
    </div>
  );
};

export default LoopNode;
